import React from "react";

const FEATURES = [
  { icon: "ph-storefront", title: "100+ Vendors", text: "Wide range of choices from top vendors" },
  { icon: "ph-shield-check", title: "Trusted Warranty", text: "Quality assured with reliable warranties" },
  { icon: "ph-truck", title: "Express Delivery", text: "Fast & reliable delivery service" },
  { icon: "ph-headset", title: "Customer Support", text: "24/7 expert support for your needs" },
];

/** Store promises shown above the footer: icon, title and one line each. */
const ShippingFeatures = () => (
  <section className="shipping features-strip" id="shipping" aria-label="Why shop with Bigmall">
    <div className="container container-lg">
      <ul className="features-strip__list">
        {FEATURES.map(({ icon, title, text }) => (
          <li key={title} className="features-strip__item">
            <span className="features-strip__icon" aria-hidden="true">
              <i className={`ph-fill ${icon}`} />
            </span>
            <span className="features-strip__body">
              <span className="features-strip__title">{title}</span>
              <span className="features-strip__text">{text}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default ShippingFeatures;
